var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5V4.7209C19 3.41207 18.4359 2.23372 17.5384 1.37872C16.632 0.532113 15.3828 0 13.9953 0C12.9501 0 11.9785 0.305202 11.1739 0.820064C9.86045 1.67507 9 3.09758 9 4.7209V5",
    fill: "#FFB3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5H2C0.895431 5 0 5.89543 0 7V23C0 24.1046 0.89543 25 2 25H22C23.1046 25 24 24.1046 24 23V7C24 5.89543 23.1046 5 22 5Z",
    fill: "#FFB3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25L20.9347 21L24 23.615",
    fill: "#FFB3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9V5.2828C4 2.36526 6.23864 0 9 0C11.7614 0 14 2.36526 14 5.2828V9",
    fill: "#FFB3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.91 6.43294V6.18549C17.91 5.0251 17.4382 3.98039 16.6877 3.22235C15.9296 2.47177 14.8849 2 13.7245 2C12.8504 2 12.0379 2.27059 11.3649 2.72706C10.2665 3.4851 9.54688 4.74628 9.54688 6.18549V6.43294",
    fill: "#EF9D54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.91 6.43294V6.18549C17.91 5.0251 17.4382 3.98039 16.6877 3.22235C15.9296 2.47177 14.8849 2 13.7245 2C12.8504 2 12.0379 2.27059 11.3649 2.72706C10.2665 3.4851 9.54688 4.74628 9.54688 6.18549V6.43294",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.43555H2V22.7567H22V6.43555Z",
    fill: "#66CBE2",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5059 6.43555V22.7567",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8516 22.7567L19.4567 19.5469L21.9998 21.6453",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.457 19.5469V6.43555",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37012 9.43172V6.49132C5.37012 4.18348 7.2411 2.3125 9.54894 2.3125C11.8568 2.3125 13.7278 4.18348 13.7278 6.49132V9.43172",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBag);
export default __webpack_public_path__ + "static/media/CartBag.847198f821174509f7e3c84287fba56a.svg";
export { ForwardRef as ReactComponent };